import React, { useEffect, useState, useCallback, useMemo } from "react";
import Swal from "sweetalert2";
import axiosClient from "../api/axiosClient";
import { useNavigate } from "react-router-dom";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import logo3m from "../assets/Logo/3m.jpg";
import adobe from "../assets/Logo/adobe.png";
import airtable from "../assets/Logo/airtable.png";
import akamai from "../assets/Logo/Akamai.png";
import amazon from "../assets/Logo/amazon.png";
import amplitude from "../assets/Logo/ampti.svg";
import asana from "../assets/Logo/asana.png";
import atlassian from "../assets/Logo/Atlassian.png";
import bloomberg from "../assets/Logo/bloom.png";
import canva from "../assets/Logo/canva.jpg";
import citadel from "../assets/Logo/cita.png";
import cockroach from "../assets/Logo/cockroach.png";
import coursera from "../assets/Logo/Coursera.png";
import doordash from "../assets/Logo/door.png";
import goldman from "../assets/Logo/Goldman.png";
import google from "../assets/Logo/google.png";
import instacart from "../assets/Logo/isnta.png";
import linkedin from "../assets/Logo/link.jpg";
import meta from "../assets/Logo/meta.png";
import microsoft from "../assets/Logo/micro.png";
import netflix from "../assets/Logo/netflix.png";
import oracle from "../assets/Logo/oracle.png";
import paypal from "../assets/Logo/paypal.png";
import pinterest from "../assets/Logo/pint.png";
import slack from "../assets/Logo/Slack.jpg";
import snowflake from "../assets/Logo/snow.jpg";
import twitter from "../assets/Logo/teitter.png";
import tiktok from "../assets/Logo/tittok.png";
import yahoo from "../assets/Logo/yahoo.png";
import zoom from "../assets/Logo/zoom.jpg";
import zynga from "../assets/Logo/zynga.png";
import uber from "../assets/Logo/uber.png";
import JaneStreet from "../assets/Logo/JaneStreet.png";
import stripe from "../assets/Logo/stripe.png";
import codematrixLogo from "../assets/Logo/codematrixLogo.png";

const companyLogos = {
  "3M": logo3m,
  Adobe: adobe,
  Airtable: airtable,
  Akamai: akamai,
  Amazon: amazon,
  Amplitude: amplitude,
  Asana: asana,
  Atlassian: atlassian,
  Bloomberg: bloomberg,
  Canva: canva,
  Citadel: citadel,
  Cockroach: cockroach,
  Coursera: coursera,
  DoorDash: doordash,
  Goldman: goldman,
  Google: google,
  Instacart: instacart,
  Linkedin: linkedin,
  Meta: meta,
  Microsoft: microsoft,
  Netflix: netflix,
  Oracle: oracle,
  Paypal: paypal,
  Pinterest: pinterest,
  Slack: slack,
  Snowflake: snowflake,
  Twitter: twitter,
  TikTok: tiktok,
  Yahoo: yahoo,
  Zoom: zoom,
  Zynga: zynga,
  Uber: uber,
  "Jane Street": JaneStreet,
  Stripe: stripe,
};

const COLORS = [
  "#6366f1",
  "#22c55e",
  "#f59e0b",
  "#ef4444",
  "#06b6d4",
  "#a855f7",
  "#14b8a6",
  "#e11d48",
  "#0ea5e9",
  "#f97316",
  "#10b981",
];

const DetailModal = ({ isOpen, onClose, content, companyName }) => {

  const filteredData = useMemo(() => {
    return Array.isArray(content)
      ? content.filter((item) => item.value > 0)
      : [];
  }, [content]);
  // console.log(filteredData);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!isOpen) return null;



  // const filteredData = content.filter((item) => item.value > 0);




  const renderCustomLabel = ({ cx, cy, midAngle, outerRadius, percent, name }) => {
    const RADIAN = Math.PI / 180;

    // label ko bahar push kar rahe hain
    const radius = outerRadius + 10;

    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="#111"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
        style={{
          fontSize: "11px",
          fontWeight: "500"
        }}
      >
        {`${name} ${(percent * 100).toFixed(1)}%`}
      </text>
    );
  };



  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          padding: "30px",
          width: "95%",
          maxWidth: "850px",
          position: "relative",
          boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "15px",
            right: "18px",
            border: "none",
            fontSize: "22px",
            background: "none",
            cursor: "pointer",
          }}
        >
          ✖
        </button>

        <img
          src={codematrixLogo}
          alt="CodeMatrix"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "360px",
            opacity: 0.08,
            pointerEvents: "none",
            zIndex: 0,
            // filter: "blur(1.2px)",
          }}
        />

        <h2
          style={{
            textAlign: "center",
            marginBottom: "25px",
            position: "relative",
            zIndex: 1,
          }}
        >
          {companyName} Problem Pattern Analysis
        </h2>

        <div
          style={{
            width: "100%",
            maxWidth: "750px",
            margin: "auto",
            // overflow:"visible"
            // aspectRatio: "16 / 10" 
          }}
        >
          <ResponsiveContainer width="100%" height={isMobile ? 300 : 380} >
            <PieChart>
              <Pie
                data={filteredData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy={isMobile ? "50%" : "45%"}
                innerRadius={isMobile ? "35%" : "40%"}
                outerRadius={isMobile ? "75%" : "70%"}
                paddingAngle={3}
                minAngle={5}
                // labelLine={true}
                // label={renderCustomLabel}
                labelLine={true}
                label={({ name, percent }) =>
                  `${name} ${(percent * 100).toFixed(0)}%`
                }
                isAnimationActive={false}

              >
                {filteredData.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>

              <Tooltip
                formatter={(value, name) => [
                  typeof value === "number" ? `${value.toFixed(1)}%` : value,
                  name,
                ]}
              />

              <Legend
                verticalAlign="bottom"
                align="center"
                layout="horizontal"
                iconType="circle"
                wrapperStyle={{
                  marginTop: "30px",
                  fontSize: "13px",
                  lineHeight: "24px",
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default function Dashboard() {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detailData, setDetailData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const loadCompanies = async () => {
      try {
        const res = await axiosClient.get(
          "/no-auth/api/users/allCompanyTopicPercent",
        );

        const finalData = res.data?.data || res.data;

        const grouped = {};

        finalData.forEach((item) => {
          const id = item.company.id;

          if (!grouped[id]) {
            grouped[id] = {
              id: id,
              companyName: item.company.companyName,
            };
          }
        });

        // 👇 convert object → array
        const companies = Object.values(grouped);

        // 👇 alphabetical sorting
        companies.sort((a, b) => a.companyName.localeCompare(b.companyName));

        setData(companies);
      } catch {
        Swal.fire("Error", "Failed to load companies", "error");
      } finally {
        setLoading(false);
      }
    };

    loadCompanies();
  }, []);

  const handleCardClick = async (item) => {
    setSelectedCompany(item.companyName);

    const res = await axiosClient.get(
      `/no-auth/api/users/companyID/${item.id}`,
    );

    const apiData = res.data?.data || res.data;

    const chartData = apiData.map((item) => ({
      name: item.topic.topicName,
      value: item.percentage,
    }));

    // ✅ only update if valid
    if (chartData.length > 0) {
      setDetailData(chartData);
      setIsModalOpen(true);
    }

    setDetailData(chartData);
    setIsModalOpen(true);
  };

  return (
    <div
      style={{
        padding: "50px 20px",
        background: "#fff",
        minHeight: "100vh",
        marginTop:"10vh",
      }}
    >
      {/* <button
        onClick={() => navigate("/front")}
        style={{
          position: "absolute",
          right: "20px",
          top: "50px",
          border: "none",
          padding: "8px 18px",
          borderRadius: "30px",
          cursor: "pointer",
          background: "#fff",
          boxShadow: "0 6px 15px rgba(0,0,0,0.15)",
        }}
      >
        🏠Home
      </button> */}

      <h1
        style={{
          textAlign: "center",
          fontSize: "36px",
          fontWeight: "800",
        }}
      >
        Explore Top Tech Companies
      </h1>

      <p
        style={{
          textAlign: "center",
          color: "#64748b",
          marginBottom: "40px",
        }}
      >
        Select a company and start your interview preparation journey
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
          gap: "30px",
          maxWidth: "1200px",
          margin: "auto",
        }}
      >
        {!loading &&
          data.map((item, index) => (
            <div
              key={index}
              onClick={() => handleCardClick(item)}
              style={{
                background: "#fff",
                borderRadius: "20px",
                padding: "35px 20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                transition: "0.3s",
                boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
              }}
            >
              <img
                src={companyLogos[item.companyName] || google}
                style={{
                  width: "90px",
                  height: "90px",
                  objectFit: "contain",
                  marginBottom: "10px",
                }}
                alt=""
              />

              <h3 style={{ fontWeight: "700", marginBottom: "5px" }}>
                {item.companyName}
              </h3>

              <span
                style={{
                  fontSize: "13px",
                  color: "#6366f1",
                }}
              >
                View Topics →
              </span>
            </div>
          ))}
      </div>

      <DetailModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        content={detailData}
        companyName={selectedCompany}
      />
    </div>
  );
}
